import {Component, OnInit} from '@angular/core';
import {ServerResponse} from 'http';
import {Observable} from 'rxjs';
import {ApiService} from '../custom-services/ApiService';
import { HttpParams } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Loader, NgxUiLoaderService} from "ngx-ui-loader";
import { environment } from '../../environments/environment';
import { DataService } from '../service/data.service';
import { CommonUtilService } from '../service/utils/common-utils';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-trp-landing',
    templateUrl: './trp-landing.component.html',
    styleUrls: ['./trp-landing.component.css'],
    standalone: false
})
export class TrpLandingComponent implements OnInit {

  routeId = '';
  private refreshToken: string = '';
  assessmentYearApiPath: string = '/filingservice/v3/api/assessment-year/get';
  
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private jwtHelper: JwtHelperService,
    private router: Router,
    private loader: NgxUiLoaderService,
    private dataService: DataService,
    private toastr: ToastrService,
    ) { 
      
    }

  ngOnInit(): void {
    this.loader.start();
    this.route.paramMap.subscribe(params => {
      this.loader.start();
      this.routeId = params.get('token');
      this.refreshToken = params.get('refreshToken');
      this.trpStorageSet();
    });

  }

  trpStorageSet(){
    localStorage.setItem('token', this.routeId);
    localStorage.setItem('refresh_token', this.refreshToken);
    let tokenInfo = this.jwtHelper.decodeToken(this.routeId)['claims'];
    let userName = tokenInfo['userFullName'];
    localStorage.setItem('name', userName);
    let tin = tokenInfo['userIdentity'];
    localStorage.setItem('tin', tin);
    this.router.navigate(["/user-panel/home"]).then(r => this.loader.stop());
  }
}
